"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const LGBTQOwned = createSVGIcon(
  <>
    <path
      d="M3 14.6364C3 9.86477 6.67153 6 11.2045 6C15.7376 6 19.4091 9.86477 19.4091 14.6364H3Z"
      fill="#D4D9E4"
    />
    <path
      d="M6.97136 16.7272C7.22804 12.9424 10.377 9.95447 14.2272 9.95447C18.0774 9.95447 21.2264 12.9424 21.483 16.7272H6.97136Z"
      stroke="#312921"
    />
  </>,
  "LBGTQ owned",
  {
    viewBox: "0 0 24 24",
    titleAccess: "LBGTQ owned",
    fill: "none",
  }
);
